import { render } from "./LimitedTimeView.vue?vue&type=template&id=a9b1b7f0&ts=true"
import script from "./LimitedTimeView.vue?vue&type=script&lang=ts"
export * from "./LimitedTimeView.vue?vue&type=script&lang=ts"

import "./LimitedTimeView.vue?vue&type=style&index=0&id=a9b1b7f0&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__